import pluralize from 'pluralize';

const freeSubscriptionOption = {
  id: 'free',
  text: 'Free',
};

const defaultState = () => ({
  prices: null,
  currentUserHasBeenSubscribedToProfile: false,
  subscriptionOptions: [
    freeSubscriptionOption,
  ],
  subscriptionSettings: {},
  requesterActiveSubscriptions: [],
});

const getFormattedAmount = (amount, currency) => new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency,
  minimumFractionDigits: 0,
}).format(amount);

const getInterval = (interval, count) => count > 1
  ? pluralize(interval, count, true)
  : interval;

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setPrices(state, payload) {
      state.prices = payload;
    },
    setSubscriptionSettings(state, payload) {
      state.subscriptionSettings = payload;
    },
    setSubscriptionOptions(state, payload) {
      if (payload) {
        state.subscriptionOptions = [
          freeSubscriptionOption,
          ...payload
            .map((price) => {
              const interval = getInterval(price.recurring.interval, price.recurring.interval_count);
              return {
                id: price.id,
                text: interval,
                details: `${getFormattedAmount(price.unit_amount / 100, price.currency)}/${interval}`,
              };
            }),
        ];
      }
    },
    setSubscriptionState(state, payload) {
      state.currentUserHasBeenSubscribedToProfile = payload;
    },
    reset(state) {
      Object.assign(state, defaultState());
    },
    setRequesterActiveSubscriptions(state, requesterActiveSubscriptions) {
      state.requesterActiveSubscriptions = requesterActiveSubscriptions;
    },
  },
  actions: {
    async setPrices({ commit }, payload) {
      commit('setPrices', payload);
      commit('setSubscriptionOptions', payload);
    },
    async setSubscriptionState({ commit }, payload) {
      commit('setSubscriptionState', payload);
    },
    async setRequesterActiveSubscriptions({ commit }, requesterActiveSubscriptions) {
      commit('setRequesterActiveSubscriptions', requesterActiveSubscriptions);
    },
  },
  getters: {
    prices: state => state.prices,
    currentUserHasBeenSubscribedToProfile: state => state.currentUserHasBeenSubscribedToProfile,
    requesterActiveSubscriptions: state => state.requesterActiveSubscriptions,
    subscriptionSettings: state => state.subscriptionSettings || {},
    subscriptionOptions: (state) => {
      const offerList = state.subscriptionSettings.freeTierList
        ?.map(item => ({
          paid: false,
          value: item,
        }))
        .concat(
          state.subscriptionSettings.paidTierList
            .map(item => ({
              paid: true,
              value: item,
            })),
        );

      return state.subscriptionOptions
        .map(option => ({
          ...option,
          paid: Boolean(option.id),
          offerList,
        }));
    },
  },
};
